export const VSCodeScheme = 'vscode';
export const VSCodeDevBoxExtensionId = 'DevCenter.ms-devbox';
export const VSCodeDevBoxExtensionLink = 'https://marketplace.visualstudio.com/items?itemName=DevCenter.ms-devbox';
export const VSCodeDevBoxExtensionWebHookPrefix = `${VSCodeScheme}://${VSCodeDevBoxExtensionId}`;
export const VSCodeConnectCommand = 'devbox/open';
export const VSCodeDevBoxUriParameter = 'devBoxUri';
